<template>
  <section class="page-404">
    <h2 class="page-404__title">喔不！找不到您的資料。</h2>
    <p class="page-404__description">很抱歉，請再試試，或是「返回首頁」。</p>
    <router-link
      :to="{ path: '/' }"
      class="page-404__redirect-link"
      title="返回首頁"
      >返回首頁</router-link
    >
  </section>
</template>

<script>
export default {
  name: 'PageNotFound',
  metaInfo() {
    return {
      title: '找不到您的內容 Page not found',
    };
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.page-404 {
  text-align: center;
  padding: 2rem 0;

  &__title {
    font-size: 1.25rem;
    margin-top: 0;
    margin-bottom: 20px;
  }

  &__description {
    margin-top: 0;
    margin-bottom: 35px;
  }

  &__redirect-link {
    display: inline-block;
    background-color: $color-call-to-action-bg;
    border-radius: 5px;
    padding: 0.5rem 20px;
    color: $color-call-to-action-text;
  }
}
</style>
